import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import { LoaderComponent } from "../../../Common/LoaderComponent";
import IsLogin from "../../../Common/IsLogin";
import Swal from "sweetalert2";

const List = () => {
  const location = useLocation();
  const [receiveData, setReceiveData] = useState([]);
  const [alert, setAlert] = useState(null);

  const fetchData = () => {
    Http.get("/distributor").then((res) => {
      setReceiveData(res.data);
    });
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  const deleteData = (id, deleteApiUrl, showMsg) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Http.delete("/" + deleteApiUrl + "/" + id).then((res) => {
          setReceiveData(res.data);
          Swal.fire("Deleted!", showMsg + " has been deleted.", "success");
        });
      }
    });
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">All Distributors</h5>
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />

            <div className="card pd-20 pd-sm-40">
              {/* <h6 className="card-body-title mg-sm-b-30">Datatable</h6> */}
              <div className="row">
                <div className="table-responsive p-0 pb-2">
                  <table className="table table-sm table-bordered table-striped align-items-center justify-content-center mb-0 datatable">
                    <thead>
                      <tr>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          S/N
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Code
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Name
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Depot
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Type
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          SR
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Region
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Area
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Base
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Status
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Balance
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {receiveData.map((item, index) => (
                        <tr key={item.id}>
                          <td className="text-xs">{index + 1}</td>
                          <td className="text-xs">{item.code}</td>
                          <td className="text-xs">
                            <Link
                              to={{
                                pathname: "/distributor-details/" + item.id,
                              }}
                              title="Distributor Details"
                            >
                              {item.name}
                            </Link>
                          </td>
                          <td className="text-xs">
                            {item.factory ? item.factory.name : ""}
                          </td>
                          <td className="text-xs">{item.business_type}</td>
                          <td className="text-xs">
                            {item.sr_base_info
                              ? item.sr_base_info.map((item2, index2) =>
                                  item2.base ? (
                                    <span
                                      key={index2}
                                      className="badge bg-secondary me-1"
                                      style={{
                                        fontSize: "80%",
                                        fontWeight: 300,
                                      }}
                                    >
                                      {item2.base.user
                                        ? item2.base.user.name
                                        : ""}
                                    </span>
                                  ) : (
                                    ""
                                  )
                                )
                              : ""}
                          </td>
                          <td className="text-xs">
                            {item.distributor_workplace
                              ? item.distributor_workplace.map(
                                  (item2, index2) =>
                                    item2.region ? (
                                      <span
                                        key={index2}
                                        className="badge bg-secondary me-1"
                                        style={{
                                          fontSize: "80%",
                                          fontWeight: 300,
                                        }}
                                      >
                                        {item2.region.name}
                                      </span>
                                    ) : (
                                      ""
                                    )
                                )
                              : ""}
                          </td>
                          <td className="text-xs">
                            {item.distributor_workplace
                              ? item.distributor_workplace.map(
                                  (item2, index2) =>
                                    item2.area ? (
                                      <span
                                        key={index2}
                                        className="badge bg-secondary me-1"
                                        style={{
                                          fontSize: "80%",
                                          fontWeight: 300,
                                        }}
                                      >
                                        {item2.area.name}
                                      </span>
                                    ) : (
                                      ""
                                    )
                                )
                              : ""}
                          </td>
                          <td className="text-xs">
                            {item.distributor_workplace
                              ? item.distributor_workplace.map(
                                  (item2, index2) =>
                                    item2.base ? (
                                      <span
                                        key={index2}
                                        className="badge bg-secondary me-1"
                                        style={{
                                          fontSize: "80%",
                                          fontWeight: 300,
                                        }}
                                      >
                                        {item2.base.name}
                                      </span>
                                    ) : (
                                      ""
                                    )
                                )
                              : ""}
                          </td>
                          <td className="text-xs text-right">
                            <span
                              className={`badge ${
                                item.status === "active"
                                  ? "bg-primary"
                                  : "bg-danger"
                              } me-1`}
                              style={{
                                fontSize: "80%",
                                fontWeight: 300,
                              }}
                            >
                              {item.status}
                            </span>
                          </td>
                          <td className="text-xs text-right">
                            {parseFloat(item.balance).toFixed(2)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default List;
